module.exports = __webpack_public_path__ + "img/structure-img.6d4cd4d0.png";